<template>
    <b-col class="sag-form-checkbox">
        <label :id="'lab_' + id" :for="id">{{ label }}</label>
        <b-form-checkbox 
            :id="id" 
            v-model="refSagChecked"
            v-bind="$attrs"
        ></b-form-checkbox>
    </b-col>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { BCol, BFormCheckbox } from 'bootstrap-vue'
export default {
    components: {
        BFormCheckbox,
        BCol
    },
    props: {
        label: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        sagValue: {
            type: Boolean,
            default: false
        }
    },
    setup(props, { emit }){
        const refSagChecked = ref(props.sagValue)

        watch(refSagChecked, (newValue, oldValue)=>{
            emit('sagChangeEvent', {
                name: props.id,
                value: newValue
            })
        })

        emit('sagRefreshData', {
            key: props.id,
            value: (newValue)=>{
                refSagChecked.value = newValue
            }
        })

        return {
            refSagChecked
        }
    }
}
</script>